import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type { DRAWER_IDS } from 'lumen/utils/constants/general-constants';

export type DrawerID = (typeof DRAWER_IDS)[keyof typeof DRAWER_IDS];

export default class DrawerService extends Service {
  @tracked drawerStates = new Map<DrawerID, boolean>();

  collapseDrawer(drawerId: DrawerID): void {
    this.drawerStates.set(drawerId, false);

    // update tracked object
    // eslint-disable-next-line no-self-assign
    this.drawerStates = this.drawerStates;
  }

  expandDrawer(drawerId: DrawerID): void {
    this.drawerStates.set(drawerId, true);

    // update tracked object
    // eslint-disable-next-line no-self-assign
    this.drawerStates = this.drawerStates;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  isDrawerExpanded(drawerId: DrawerID) {
    if (this.drawerStates.has(drawerId)) {
      return this.drawerStates.get(drawerId);
    }

    return null;
  }

  registerDrawer(drawerId: DrawerID): void {
    this.drawerStates.set(drawerId, false);
  }

  toggleDrawerState(drawerId: DrawerID): void {
    if (this.drawerStates.has(drawerId)) {
      this.drawerStates.set(drawerId, !this.drawerStates.get(drawerId));
    }

    // update tracked object
    // eslint-disable-next-line no-self-assign
    this.drawerStates = this.drawerStates;
  }
}

declare module '@ember/service' {
  interface Registry {
    drawer: DrawerService;
  }
}
